import { useState } from 'react';
import { toast } from 'react-toastify';

import { useFreecodeContextData } from 'hooks/useContext';
import services from 'api/services';
const { FreecodeCreatorService } = services;

export const useExportZip = () => {
  const { test, testImpl } = useFreecodeContextData();

  const [exporting, setExporting] = useState(false);

  const exportZip = async () => {
    if (!test) return toast.error('Test Not Found');
    if (exporting) return toast.error('Already Exporting');
    setExporting(true);

    let link;
    try {
      const response = await FreecodeCreatorService.exportFreecode(test._id, testImpl._id);
      link = document.createElement('a');
      link.href = 'data:application/zip;base64,' + response;
      link.download = (test.name || 'freecode') + '.zip';
      link.click();
    } catch (e) {
      toast.error(typeof e === 'string' ? e : e?.message || 'Could not export');
    } finally {
      link?.remove?.();
      setExporting(false);
    }
  };
  return [exportZip, exporting];
};
